import { useCallback } from 'react';
import UriTemplate from 'uri-template-lite';
import { path } from '../../paths';
import { ValidationRuleTestValidationType } from '@atlas-frontend/sdk';

export function useOpenTestValidationReport() {
  return useCallback((params: ValidationRuleTestValidationType) => {
    const url = new UriTemplate(
      `${path.outputDataTestValidationReport}{?validationRuleId,valueDate,outputDataVersionId}`,
    ).expand({
      validationRuleId: params.validationRuleId,
      valueDate: params.valueDate,
      outputDataVersionId: params.outputDataVersionId,
    });

    window.open(url, '_blank');
  }, []);
}
